import { render } from "./Sudoku.vue?vue&type=template&id=2b13357e&scoped=true&bindings={}"
import script from "./Sudoku.vue?vue&type=script&lang=ts"
export * from "./Sudoku.vue?vue&type=script&lang=ts"

import "./Sudoku.vue?vue&type=style&index=0&id=2b13357e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b13357e"

export default script